module.exports = __webpack_public_path__ + "img/community.a8d3640c.svg";